import { render, staticRenderFns } from "./TTMultiselectGroup.vue?vue&type=template&id=052022ae&scoped=true&"
import script from "./TTMultiselectGroup.vue?vue&type=script&lang=js&"
export * from "./TTMultiselectGroup.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./TTMultiselectGroup.vue?vue&type=style&index=1&id=052022ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052022ae",
  null
  
)

export default component.exports